<template>
  <div class="container-c-time">
    <van-popup v-model="showPop" position="bottom" :style="{ height: '35%' }" @close="closePop">
      <van-datetime-picker
        title=""
        type="year-month"
        :cancel-button-text="$t('lang.BaseCommon.k006')"
        :confirm-button-text="$t('lang.BaseCommon.k028')"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="currentDate"
        @confirm="confirm(currentDate)"
        @cancel="cancel(currentDate)"
      />
    </van-popup>
  </div>
</template>

<script>
// 这个是 （ 年 月 ） 格式
export default {
  props: {
    showPop: {
      default: false,
    },
  },
  data() {
    return {
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2099, 11, 1),
      currentDate: new Date(),
      chooseTime: '',
    }
  },
  methods: {
    confirm(time) {
      this.chooseTime = time
      this.$parent.closePop()
      this.$emit('handleCurrentDate', this.chooseTime)
    },
    cancel() {
      this.$parent.closePop()
    },
    closePop() {
      this.$parent.closePop()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .van-icon-arrow-down:before {
  color: pink !important;
}
</style>
